import { useState, useEffect, useCallback } from 'react';

export const useScrollDirection = (threshold = 50, showHeaderThreshold = 150) => {
  const [scrollDirection, setScrollDirection] = useState<'up' | 'down' | null>(null);
  const [prevScrollY, setPrevScrollY] = useState(0);
  const [isNearTop, setIsNearTop] = useState(true);

  // Reset state when route changes
  const resetState = useCallback(() => {
    setScrollDirection(null);
    setPrevScrollY(0);
    setIsNearTop(true);
  }, []);

  useEffect(() => {
    // Listen for route change events to reset state
    window.addEventListener('route-change', resetState);
    return () => window.removeEventListener('route-change', resetState);
  }, [resetState]);

  useEffect(() => {
    // Utiliser #root comme conteneur scrollable (fix iOS rubber-band)
    const scrollContainer = document.getElementById('root');
    
    if (!scrollContainer) return;

    const handleScroll = () => {
      const currentScrollY = scrollContainer.scrollTop;

      // Vérifier si on est proche du top
      setIsNearTop(currentScrollY < showHeaderThreshold);

      // Réinitialiser la direction quand on est tout en haut (fix iOS)
      if (currentScrollY <= 10) {
        setScrollDirection(null);
        setPrevScrollY(0);
        return;
      }

      // Ignorer les petits mouvements
      if (Math.abs(currentScrollY - prevScrollY) < threshold) {
        return;
      }

      // Déterminer la direction
      if (currentScrollY > prevScrollY) {
        // Scroll vers le bas
        setScrollDirection('down');
      } else {
        // Scroll vers le haut
        setScrollDirection('up');
      }

      setPrevScrollY(currentScrollY);
    };

    scrollContainer.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [prevScrollY, threshold, showHeaderThreshold]);

  return { scrollDirection, isNearTop };
};
